import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'player-stop', 'PlayerStop', [["path",{"d":"M5 7a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -10"}]]);